import React from "react";
import "./App.scss";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import NavMenu from "./components/App/shared/NavMenu";
import Trending from "./components/App/Trending";
import WhoToFollow from "./components/App/WhoToFollow";
import UserControls from "./components/App/shared/UserControls";
import NewsFeed from "./components/App/NewsFeed";
import Profile from "./components/App/Profile";
import Notifications from "./components/App/Notifications";
import Inbox from "./components/App/Inbox";
import { Sendbird } from "./api/sendbird";
import { connect } from "react-redux";
import HvControlPanel from "./components/App/HvControlPanel";
import HvPlayer from "./components/HvPlayer";
import Settings from "./components/App/Settings";
import PostPage from "./components/App/PostPage";
import SoundTrackPage from "./components/App/SoundTrackPage";
import Browse from "./components/App/Browse";
import Dashboard from "./components/App/Dashboard";
import DragAndDrop from "./components/DragAndDrop";
import TipJarSidePanel from "./components/App/shared/TipJarSidePanel";
import InviteFriends from "./components/App/shared/InviteFriends";
import Queue from "./components/App/Queue";
import Upload from "./components/App/Upload";
import SearchBar from "./components/App/shared/SearchBar";
import BlogSection from "./components/App/BlogSection";
import BrandLogo from "./components/shared/BrandLogo";
import HvHeader from "./components/App/shared/HvHeader";
import MenuDivider from "./components/shared/MenuDivider";
import Trends from "./components/App/Browse/Trends";
import Login from "./components/Onboarding/routes/login.js";
import { addUnauthorizedCallback, log_error } from "./api";
import { login, logout } from "./api/authentication";
import { addComment } from "./api/comments";
import AiManager from "./components/App/AiManager";
import Join from "./components/App/Join";

const sendbird_client = new Sendbird();
const authRoutes = ["login", "signup", "about", "forgot_password"];

class AppRouter extends React.Component {
  state = { sb_connection: null, handler: null, showLogin: false };
  componentDidMount = async () => {
    await this.initSbConnection();
    addUnauthorizedCallback(this.onUnauthorizedActionAttempt);
  };
  componentWillUnmount() {
    sendbird_client.sb.removeConnectionHandler("inbox_index");
  }
  pages = {
    browse: (props) => <Browse {...props} />,
    inbox: (props) => <Inbox {...props} sb_connection={this.state.sb_connection} initSbConnection={this.initSbConnection} />,
    postPage: (props) => <PostPage {...props} />,
    soundTrackPage: (props) => <SoundTrackPage {...props} />,
    newsFeed: (props) => <NewsFeed {...props} user={this.props.current_user} className="main" tweetBox showTabsToggle header pageSize={1} />,
    profile: (props) => <Profile {...props} />,
    theLatest: (props) => <Trends {...props} />,
    settings: () => <Settings />,
    notifications: () => <Notifications />,
    upload: () => <Upload />,
    nowPlaying: () => <Queue />,
    dashboard: () => <Dashboard />,
    aiManager: () => <AiManager />,
    join: () => <Join />,
  };
  sideBar = () => (
    <div id="right_col" className="col-22 shadow-sm">
      <UserControls />
      <SearchBar onQuery={this.onQueryFromSearch} />
      <InviteFriends />
      <TipJarSidePanel />
      <Trending />
      <MenuDivider thick />
      <WhoToFollow />
      {this.props.current_user ? <MenuDivider thick /> : null}
      <BlogSection />
    </div>
  );

  onUnauthorizedActionAttempt = () => {
    this.setState({ showLogin: true });
  };

  onLogin = async (loginParams) => {
    try {
      await login(loginParams);

      // Add comments to the media after login
      const comments_before_login = JSON.parse(localStorage.getItem("comments_before_login"));
      if (comments_before_login) {
        await addComment(comments_before_login.type, comments_before_login.id, comments_before_login.params);
        localStorage.removeItem("comments_before_login");
      }

      window.location.reload();
    } catch (error) {
      throw log_error(error);
    }
  };

  render() {
    return (
      <Router>
        {this.state.showLogin && <Login onLogin={this.onLogin} onCancel={() => this.setState({ showLogin: false })} />}
        <div id="hv" className="container-fluid">
          <div className="row no-gutters">
            <div id="left_col" className="col-18 shadow-sm">
              <BrandLogo />
              <NavMenu />
            </div>
            <div id="middle_col" className="col shadow-sm">
              <Switch>
                <Route component={HvHeader} path="/" exact />
                <Route component={HvHeader} path="/browse" />
                <Route component={HvHeader} path="/dashboard" />
                <Route component={HvHeader} path="/messages" />
                <Route component={HvHeader} path="/settings" />
                <Route component={HvHeader} path="/post/:id" />
                <Route component={HvHeader} path="/upload/:upload_type" />
                <Route component={HvHeader} path="/now-playing" />
                <Route component={HvHeader} path="/notifications" />
                <Route component={HvHeader} path="/settings" />
                <Route component={null} />
              </Switch>
              <Switch>
                <Route path="/" exact component={this.pages.newsFeed} />
                <Route path="/newsfeed" exact component={this.pages.newsFeed} />
                <Route path="/logout" exact render={logout} />
                <Route path="/browse" exact render={this.pages.browse} />
                <Route path="/dashboard" exact render={this.pages.dashboard} />
                <Route path="/messages" exact render={this.pages.inbox} />
                <Route path="/settings" component={this.pages.settings} />
                <Route path="/the-latest" component={this.pages.theLatest} />
                <Route path="/post/:id" exact component={this.pages.postPage} />
                <Route path="/sound_track/:id" exact component={this.pages.soundTrackPage} />
                <Route path="/upload/:upload_type" render={this.pages.upload} />
                <Route path="/now-playing" exact component={this.pages.nowPlaying} />
                <Route path="/notifications" exact component={this.pages.notifications} />
                <Route path="/ai-music-manager" exact component={this.pages.aiManager} />
                <Route path="/join" exact component={this.pages.join} />
                <Route path="/refer" exact component={this.pages.newsFeed} />
                {/* add whitelist entries to match public routes, it will redirect to current user */}
                {authRoutes.map((route, id) => (
                  <Redirect key={id} from={`/${route}`} to={`/${this.props?.current_user?.slug}`} />
                ))}
                <Route path="/:slug" component={this.pages.profile} />
              </Switch>
            </div>
            <Switch>
              {/* <Route path="/settings" component={<></>} /> */}
              <Route path="/" component={this.sideBar} />
            </Switch>
            <div id="bottom_bar" className="col-100 shadow-sm bg-dark">
              <HvControlPanel />
            </div>
          </div>
          <HvPlayer />
          <DragAndDrop />
        </div>
      </Router>
    );
  }
  initSbConnection = async () => {
    try {
      this.setState({
        sb_connection: "CONNECTING",
      });
      let sb_token = localStorage.getItem("sb_token") || sessionStorage.getItem("sb_token");
      await sendbird_client.connect(this.props.current_user.id, sb_token);
      this.setState({
        sb_connection: sendbird_client.sb.getConnectionState(),
      });
      if (this.state.handler) sendbird_client.sb.removeConnectionHandler("connection_handler");
      this.setState({ handler: "connection_handler" });
      let ConnectionHandler = new sendbird_client.sb.ConnectionHandler();
      ConnectionHandler.onReconnectStarted = () =>
        this.setState({
          sb_connection: sendbird_client.sb.getConnectionState(),
        });
      ConnectionHandler.onReconnectSucceeded = () =>
        this.setState({
          sb_connection: sendbird_client.sb.getConnectionState(),
        });
      ConnectionHandler.onReconnectFailed = () =>
        this.setState({
          sb_connection: sendbird_client.sb.getConnectionState(),
        });
      sendbird_client.sb.addConnectionHandler("connection_handler", ConnectionHandler);
    } catch (error) {
      console.log(error);
      this.setState({
        sb_connection: sendbird_client.sb.getConnectionState(),
      });
    }
  };
}
export default connect((a) => ({
  current_user: a.current_user,
}))(AppRouter);
